import UnicoUtils from './script-utils.js';

/**
 * コレクションナビゲーション
 */
export default class CollectionNav extends HTMLElement {
  constructor() {
    super();

    this.items = this.querySelectorAll('.unico-collection-nav-list-item');
    this.links = this.querySelectorAll('.unico-collection-nav-link');
    this.searchParams = new URLSearchParams(location.search);

    this._linkClickListener = this.linkClick.bind(this);
    this.links.forEach((link) => {
      link.addEventListener('click', this._linkClickListener);
    });
    
    this.init();
  }
  init() {
    const currentTag = this.searchParams.get('filter.p.tag');

    if (currentTag) {
      this.items.forEach((item) => {
        if (item.dataset.targetTag === currentTag) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }
  }
  linkClick(e) {
    e.preventDefault();
    const targetTag = e.target?.parentNode?.dataset?.targetTag;

    if (targetTag === 'すべて') {
      this.searchParams.delete('filter.p.tag');  
    } else {
      this.searchParams.set('filter.p.tag', targetTag);
    }
    this.searchParams.delete('page');
    history.pushState(
      null,
      '',
      location.pathname + '?' + this.searchParams.toString(),
    );
    this.items.forEach((item) => {
      if (item.dataset.targetTag === targetTag) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
    
    document.querySelector('unico-search-area')?.sectionUpdateRender();
    if (UnicoUtils.isSP()) {
      document.dispatchEvent(new CustomEvent('search-area-close'));
    }
  }
}
